import { render, staticRenderFns } from "./Pagination01.vue?vue&type=template&id=bf61f76a"
import script from "./Pagination01.vue?vue&type=script&lang=js"
export * from "./Pagination01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports